export default __webpack_public_path__ + "static/media/RituBirla.fa0e4868.jpg";